export default "__VITE_ASSET__XMKXaA9y__"